/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useRef, useEffect } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { useSelector } from 'react-redux';
import f from '../../helpers/formatter';
import f2 from '../../helpers/formatter2';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { CACHE_CONFIG_TYPES } from '@intigral/constant';
import { useConfigurationSections } from '../../hooks/useConfiguration';
import { IStore } from '../../interfaces/StoreTypes';
import _ from 'lodash';

interface SelectProfileLoaderProps {
    loadingProfile?: any;
    autoCloseLoading?: any;
    onClose?: () => void;
    onSuccess?: () => void;
}

const SelectProfileLoader: React.FC<SelectProfileLoaderProps> = ({
    loadingProfile = false,
    autoCloseLoading = false,
    onClose = () => {},
    onSuccess = () => {},
}) => {
    // Using React Query instead of Redux for configuration
    const { profile: profileConfig } = useConfigurationSections();
    const profileColors = profileConfig?.colors || [];
    const popupRef = useRef(null);

    useEffect(() => {
        if (!popupRef.current) {
            return;
        }
        // disable body scroll on show popup
        if (loadingProfile && popupRef?.current) {
            // auto close loading popup
            if (autoCloseLoading) {
                setTimeout(() => {
                    popupRef.current.style.display = 'none';
                    onClose();
                }, autoCloseLoading);
            }
            disableBodyScroll(popupRef?.current);
        } else {
            if (popupRef?.current) {
                enableBodyScroll(popupRef?.current);
            }
            clearAllBodyScrollLocks();
        }
    }, [autoCloseLoading, loadingProfile, popupRef?.current]);

    return (
        <>
            {loadingProfile && loadingProfile !== null && (
                <div
                    className="loader-container selectProfile-loader-main"
                    ref={popupRef}
                    style={{ display: loadingProfile ? 'flex' : 'none' }}
                >
                    <div className="selectProfile-loader">
                        <span
                            className={`selectProfile-icon ${
                                f2.isArabicText(loadingProfile.profileName)
                                    ? f.isArDownLetters(_.first(loadingProfile.profileName))
                                        ? 'avatar_ar spacialLetters'
                                        : 'avatar_ar'
                                    : ''
                            }`}
                            style={{ backgroundColor: profileColors[loadingProfile.avatar] }}
                        >
                            {_.first(loadingProfile.profileName)}
                        </span>
                        <span
                            className={`selectProfile-name ${
                                f2.isArabicText(loadingProfile.profileName) ? 'profile-name_ar' : ''
                            }`}
                        >
                            {loadingProfile.profileName}
                        </span>
                    </div>
                    <div className="loader">
                        <svg className="spinner" viewBox="0 0 50 50">
                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
                        </svg>
                    </div>
                </div>
            )}
        </>
    );
};

export default SelectProfileLoader;
